import * as React from "react";

const SvgSleetSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__a">
        <path d="M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__b">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__c">
        <path d="M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__d">
        <path d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__e">
        <path d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__f">
        <path d="m319.147 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__g">
        <path d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__h">
        <path d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="SleetSun_svg__i">
        <path d="m325.147 675.503-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001" />
      </clipPath>
    </defs>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 288 -182.15)"
      d="M-216 136.612h72v72h-72z"
    />
    <g
      clipPath="url(#SleetSun_svg__a)"
      style={{
        fill: "#fec025",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -364.778 765.511)"
    >
      <g
        style={{
          fill: "#fec025",
          fillOpacity: 1,
        }}
      >
        <path
          d="M312.685 556.184c0-7.16 5.804-12.963 12.964-12.963 7.158 0 12.963 5.803 12.963 12.963 0 7.159-5.805 12.963-12.963 12.963-7.16 0-12.964-5.804-12.964-12.963"
          style={{
            fill: "#fec025",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__b)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -364.778 765.511)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.006-.253.006-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(322.129 528.494)"
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__c)"
      style={{
        fill: "#d4e9f8",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -364.778 765.511)"
    >
      <g
        style={{
          fill: "#d4e9f8",
          fillOpacity: 1,
        }}
      >
        <path
          d="M315.904 545.066c-.052.001-.104.004-.157.004a8.288 8.288 0 0 1 0-16.576h20.599a6.696 6.696 0 0 1 0 13.392l-.068-.002c-.596 5.339-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.31"
          style={{
            fill: "#d4e9f8",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__d)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__e)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__f)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m319.147 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__g)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__h)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#SleetSun_svg__i)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -390.82 1046.967)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m325.147 675.503-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
  </svg>
);

export default SvgSleetSun;
